import {
  Form,
  Modal,
  Input,
  Switch,
} from "antd";
import { useEffect, useState } from "react";
import ShopSelect from '../../../../components/BaseInfoSelects/StoreSelectBase'
import AreaSelect from '../../../../components/AreaSelect';

const ModalComponent = (props) => {
  const {
    visible = false,
    title,
    onCancel = () => { },
    onOk = () => { },
    modalData = {},
  } = props;

  const [form] = Form.useForm()
  const [initVal, setInitVal] = useState({})
  const [deliveryArea, setDeliveryArea] = useState([])

  const selectAreaSelect = (value, selectedOptions) => {
    if (selectedOptions.length === 3) {
      form.setFieldsValue({
        deliveryArea: selectedOptions.filter(item => item.areaCode),
        provinceCode: selectedOptions[0].areaCode,
        provinceName: selectedOptions[0].areaName,
        cityCode: selectedOptions[1].areaCode,
        cityName: selectedOptions[1].areaName,
        areaCode: selectedOptions[2].areaCode,
        areaName: selectedOptions[2].areaName,
      })
    }
  }
  // 表单验证
  const validate = (val) => {
    form.validateFields().then(res => {
      onOk({
        ...val,
        deliveryArea: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        areaCode: '',
        areaName: '',
      })
    }).catch()
  }
  // 表单提交
  const submitFormVal = () => {
    const subVal = form.getFieldValue()
    subVal.status = subVal.status ? 1 : 0
    validate(subVal)
  }

  useEffect(() => {
    if (JSON.stringify(modalData) !== '{}') {
      form.setFieldsValue({
        ...modalData,
        status: modalData.status ? true : false,
        deliveryArea: [modalData.provinceCode, modalData.cityCode, modalData.areaCode]
      })
      setDeliveryArea([modalData.provinceCode, modalData.cityCode, modalData.areaCode])
    }
  }, [modalData])

  useEffect(() => {
    if (!visible) {
      form.resetFields()
      setDeliveryArea([])
    }
  }, [visible])

  return (
    <Modal
      visible={visible}
      title={title}
      centered
      closable={false}
      maskClosable={false}
      onCancel={onCancel}
      onOk={submitFormVal}
      cancelText="取消"
      okText="确认"
    >
      <Form
        form={form}
        labelCol={{ span: 5 }}
        initialValues={initVal}
      >
        <Form.Item name="id" style={{ display: "none" }}>
          <></>
        </Form.Item>
        <Form.Item
          name="title"
          label="名称"
          rules={[{ required: true, message: "请输入名称" }]}
        >
          <Input style={{ width: 260 }} placeholder="请输入名称" />
        </Form.Item>
        <Form.Item
          name="outStoreNo"
          label="所属门店"
          rules={[{ required: true, message: "请选择所属门店" }]}
        >
          <ShopSelect style={{ width: 260 }} ></ShopSelect>
        </Form.Item>
        {/* <Form.Item
          name="deliveryArea"
          label="区域"
          rules={[{ required: true, message: "请选择区域" }]}
        >
          <AreaSelect
            deliveryArea={deliveryArea}
            style={{ width: 260 }}
            multiple={false}
            isCounty
            placeholder="请选择区域"
            onChange={selectAreaSelect}
          />
        </Form.Item> */}
        <Form.Item
          name="address"
          label="详细地址"
          rules={[{ required: true, message: "请输入详细地址" }]}
        >
          <Input style={{ width: 260 }} placeholder="请输入详细地址" />
        </Form.Item>
        <Form.Item
          name="contactName"
          label="联系人"
          rules={[{ required: true, message: "请输入联系人" }]}
        >
          <Input style={{ width: 260 }} placeholder="请输入联系人" />
        </Form.Item>
        <Form.Item
          name="contactPhone"
          label="联系人电话"
          rules={[{
            required: true,
            validator: (rule, value, callback) => {
              const reg = new RegExp(/^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/)
              if (!value) return Promise.reject('请输入联系人电话');
              if (!reg.test(value)) return Promise.reject('请输入正确的联系人电话');
              return Promise.resolve()
            }
          }]}
        >
          <Input style={{ width: 260 }} placeholder="请输入联系人电话" />
        </Form.Item>
        {
          title === '新增自提点' && <Form.Item
            name="status"
            label="状态"
            rules={[{ required: true, message: "请选择状态" }]}
          >
            <Switch ></Switch>
          </Form.Item>
        }
      </Form>
    </Modal>
  );
};

export default ModalComponent;
